import classNames from 'classnames';
import React from 'react';

import { Divider, Group, Text } from '@ekhodealer/ekho-common/rev';

import './SettingsSection.scss';

function slugify(text: string): string {
	return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

interface SettingsSectionProps {
	title: string;
	description?: React.ReactNode;
	children: React.ReactNode;
	hideDivider?: boolean;
	/** Override the auto-generated id used for TOC scroll targets */
	id?: string;
	/** Optional tag rendered next to the section title (e.g. a "Coming soon" pill) */
	tag?: React.ReactNode;
	/** When true, dims the content area and prevents interaction */
	disabled?: boolean;
}

export function SettingsSection({
	title,
	description,
	children,
	hideDivider,
	id,
	tag,
	disabled,
}: SettingsSectionProps) {
	const sectionId = id ?? slugify(title);

	return (
		<div className='settings-section' id={sectionId} data-settings-section>
			<div className='settings-section__row'>
				<div className='settings-section__header'>
					{tag ? (
						<Group itemsSpacing='8' itemsAlignY='center'>
							<Group.Item>
								<Text size='title100' weight='bold'>
									{title}
								</Text>
							</Group.Item>
							<Group.Item>{tag}</Group.Item>
						</Group>
					) : (
						<Text size='title100' weight='bold'>
							{title}
						</Text>
					)}
					{description && (
						<Text size='body' color='secondary'>
							{description}
						</Text>
					)}
				</div>
				<div
					className={classNames('settings-section__content', {
						'settings-section__content--disabled': disabled,
					})}>
					{children}
				</div>
			</div>
			{!hideDivider && <Divider />}
		</div>
	);
}
